<template>
  <div class="panel panel-default">
    <add-credentials-modal ref="modal" :credentials="channelCredentials" prefix="wp_"
                           :channel="channels[index]"></add-credentials-modal>
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">{{ channels[index].channel }}</span>
      <a><i class="fa fa-cog" aria-hidden="true" @click="openModal" content="Zugangsdaten bearbeiten" v-tippy></i></a>
      <div style="float:right">
        <span class="dot-red"
              v-if="!channels[index].foreign_id || (channels[index].publish_later && !isPast(channels[index].publish_at))"
              content="Noch nicht ausgesendet"
              v-tippy></span>
        <span class="dot-green" v-else content="Bereits ausgesendet" v-tippy></span>
      </div>
    </div>
    <div class="panel-body" v-if="credentialsAreValid">
      <vue-toastr ref="toast"></vue-toastr>
      <div style="padding-bottom: 40px;">
        <label for="">Vorschaubild</label>
        <content-preview :index="index" :content-prop="{url: channels[index].preview_image_url, type: 'preview'}" @update:channels="channelsUpdated"></content-preview>
      </div>
      <div :class="{'has-error': submitAttempted && !channels[index].category}">
        <label for="category">Kategorie</label>
        <a class="fa fa-question-circle" v-tippy
           content="Sollten Sie ihren Blog in Kategorien unterteilt haben, bitte ordnen Sie dann hier die jeweilige Kategorie zu."></a>
        <select name="category" id="category" class="form-control" v-model="channels[index].category">
          <option disabled value="">Bitte wählen</option>
          <option v-for="(category, key) in categories['wordpress']" :value="key">{{ category }}</option>
        </select>
      </div>
      <br>
      <div :class="['ckeditor-wrapper', {'ckeditor-error': submitAttempted && !channels[index].news_content}]">
        <label>Content</label>
        <ckeditor v-model="channels[index].news_content" :config="editorConfig"></ckeditor>
      </div>
      <br>
      <div class="form-group">
        <input type="checkbox" :id="`publish_later${channels[index].id}`" v-model="channels[index].publish_later">
        <label :for="`publish_later${channels[index].id}`">Später veröffentlichen</label>
      </div>
      <div v-if="channels[index].publish_later">
        <label for="publish_at">Veröffentlichungsdatum</label>
        <input type="datetime-local" v-model="channels[index].publish_at" id="publish_at" class="form-control">
      </div>
      <br>
      <button class="btn btn-sm btn-default" style="float:right" @click="deleteChannel"
              content="Aussendungskanal löschen" v-tippy>
        <i class="fa fa-trash-o" style="color:red"></i>
      </button>
    </div>
    <div class="panel-body" v-else>
      Die Zugangsdaten für diesen Aussungskanal sind nicht vollstädig. <br> <br>
      <button class="btn btn-sm btn-success" @click="openModal">Zugangsdaten bearbeiten</button>
      <button class="btn btn-sm btn-default" @click="deleteChannel" :disabled="!newsHub.is_draft"><i class="fa fa-trash-o"></i></button>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations} from "vuex";
import AddCredentialsModal from "../modal/AddCredentialsModal";
import {editorConfig} from "../editor/config";
import Uploader from "vuejs-uploader";
import ContentPreview from "../image/ContentPreview";
import {isPast} from "../../services/checkIfPast";

export default {
  name: 'Shopware',
  components: {ContentPreview, AddCredentialsModal, VueToastr, Uploader},
  props: ['context', 'index', 'url', 'newsHub'],
  data() {
    return {
      sendNotify: false,
      editorConfig: {instanceId: this.index, ...editorConfig},
    }
  },
  methods: {
    isPast,
    ...mapMutations(['getChannels', 'removeChannel']),
    channelsUpdated() {
      this.$forceUpdate();
    },
    deleteChannel() {
      this.removeChannel({id: this.context.id, index: this.index})
      this.$refs.toast.s('Aussendungskanal gelöscht');
    },
    credentialsAvailable() {
      let prefix = 'wp_';
      return !!this.channelCredentials && !!this.channelCredentials[prefix + 'url']
          && !!this.channelCredentials[prefix + 'username'] && !!this.channelCredentials[prefix + 'password'];
    },
    openModal() {
      let element = this.$refs.modal.$el
      $(element).modal('show')
    },
  },
  computed: {
    ...mapGetters({channelCredentials: 'getChannelCredentials', categories: 'getCategories', channels: 'getChannels', credentialsAreValid: 'getWpCredentialsAreValid', submitAttempted: 'getSubmitAttempted'}),
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>
<style>
.ckeditor-error .cke_chrome {
  border-color: #a94442;
}
</style>
